import React from "react";
import { documentToReactComponents, Options } from "@contentful/rich-text-react-renderer";
import { isMobile, isTablet } from "../../../utils/helpers";
import { targetBlankOption } from "../../../utils/rawToReact";
import { useLocation } from '@reach/router';

// interfaces
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { BLOCKS, Document } from "@contentful/rich-text-types";


// Compontents //
import TitleSection from "../../molecules/title-section";
import Button from "../../atoms/button/button";
import StepCard from "../../molecules/step-card/stepCard";

// Styles
import "./stepsForProcedure.scss";

const ALLIANCE_ROUTE_PATH = "proyectos-inclusion-laboral/alianza";

const renderHeaderDescriptionOptions: Options = {
   renderNode: {
      [BLOCKS.HEADING_1]: (_node, children) => <h1 className="o-steps-for-procedure__header-description__title">{children}</h1>,
      [BLOCKS.PARAGRAPH]: (_node, children) => <p className="o-steps-for-procedure__header-description__text">{children}</p>,
   }
}

const StepsForProcedure = (props: ReferenciaContenido) => {
    const { 
        tituloGeneral, 
        descripcion,
        imagenPrincipal, 
        descripcionFija,
        tituloBoton,
        redireccionBoton,
        referenciaPlantillaContenido: refPlantilla,
        tituloSeccion
    } = props;

    const location = useLocation();

    const isAllianceRoute = location.pathname.includes(ALLIANCE_ROUTE_PATH);

    return (
        <div className="o-steps-for-procedure">
            {
               (isAllianceRoute && descripcionFija) ? 
                  <div className="o-steps-for-procedure__header-description">
                        {documentToReactComponents(descripcionFija as unknown as Document, renderHeaderDescriptionOptions)}
                  </div>
               : null
            }
            <div className={`o-steps-for-procedure__title ${tituloSeccion ? 'o-steps-for-procedure__title__with-aux-text' : ''}`}>
                <TitleSection
                    title={`${tituloGeneral}`}
                    type="h2"
                />
            </div>
            {tituloSeccion && 
                <span className="o-steps-for-procedure__aux-text">{tituloSeccion}</span>
            } 
            <div className="o-steps-for-procedure__steps">
                {refPlantilla.map((item, index) => (
                    <StepCard
                        key={index}
                        descriptionTitle={item.tituloDescripcion}
                        description={documentToReactComponents(
                            item.descripcion.json, targetBlankOption
                        )}
                        mainImage={item.imagenPrincipal[0].file.url}
                    />
                ))}
            </div>
            {descripcion?.json &&
               documentToReactComponents(descripcion.json)}
                {tituloBoton && (isMobile()) && (
                  <div className="o-steps-for-procedure__description">
                     <Button
                           type="link"
                           text={tituloBoton}
                           classname={"dimensions"}
                           href={redireccionBoton}
                           isDisabled={false}
                     />
               </div>
            )}  
            {descripcionFija && !isAllianceRoute && (
                <div className="o-steps-for-procedure__bottom">
                    <img src={imagenPrincipal?.file.url} alt={imagenPrincipal?.title}/>
                    <div className="o-steps-for-procedure__bottom__fixedDescription" >
                        <p>{documentToReactComponents(descripcionFija.content[0].content[0])}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default StepsForProcedure;
